import { Popover } from 'antd'
import { MyBtn } from '~/components/ui/MyBtn'
import { MyIcon } from '~/components/ui/MyIcon'
import { toCDNImage } from '~/utils'
import styles from './RemainTimesBtn.module.css'

import { useAtom } from 'jotai'
import { memberListAtom, totalPaintPointsAtom } from './ai-form/atom'
import { useState } from 'react'
import { MemberList } from './MemberList'

export const RemainTimesBtn: React.FC<{
  className?: string
}> = ({ className }) => {
  const [memberList] = useAtom(memberListAtom)
  const [totalPaintPoints] = useAtom(totalPaintPointsAtom)

  return (
    <Popover
      overlayClassName={styles.overlayClass}
      content={<MemberList />}
      placement="bottom"
      trigger={'click'}
      destroyTooltipOnHide
    >
      <MyBtn $dark className={className}>
        <div className="flex items-center">
          {!!memberList?.length ? (
            <img
              className="w-5 h-5"
              src={toCDNImage(
                `/images/ai/equity/${memberList?.[memberList?.length - 1]?.cardType
                }.svg`
              )}
              alt=""
            />
          ) : (
            <MyIcon icon="level-origin" className="text-[20px]"></MyIcon>
          )}
          <span className="ml-1 text-neutral-800">{totalPaintPoints}积分</span>
        </div>
      </MyBtn>
    </Popover>
  )
}
